import { FixedSizeGrid } from "react-window";
import { ProductCard } from "./productCard/ProductCard";

export default function GridProducts({ gridSize, productsDataList, onSelect }) {
  if (!gridSize?.width || !gridSize?.height) return null;
  if (!productsDataList?.length) return <p>No available data.</p>;

  const remPx = parseFloat(
    window.getComputedStyle(document.documentElement).fontSize
  );
  const columnWidth = 10 * remPx; // 10rem per design
  const gap = gridSize.gap || 0;
  const availableWidth = gridSize.width || 0;
  const columnCount = Math.max(
    1,
    Math.floor((availableWidth + gap) / (columnWidth + gap))
  );
  const rowCount = Math.ceil(productsDataList.length / columnCount);
  const cardHeight = 240; // px as provided
  const itemKey = ({ columnIndex, rowIndex }) => {
    const index = rowIndex * columnCount + columnIndex;
    const item = productsDataList[index];
    return item ? item.id : `empty-${rowIndex}-${columnIndex}`;
  };

  return (
    <FixedSizeGrid
      columnCount={columnCount}
      columnWidth={columnWidth}
      height={gridSize.height}
      rowCount={rowCount}
      rowHeight={cardHeight + gap}
      width={gridSize.width || 600}
      itemKey={itemKey}
      itemData={{}}
      overscanRowCount={3}
      overscanColumnCount={1}
    >
      {({ columnIndex, rowIndex, style }) => {
        const index = rowIndex * columnCount + columnIndex;
        const product = productsDataList[index];
        if (!product) return null;
        const cellStyle = {
          ...style,
          width: style.width ?? columnWidth,
          height: cardHeight + gap,
          boxSizing: "border-box",
          paddingRight: gap,
          paddingBottom: gap,
        };
        return (
          <div style={cellStyle}>
            <ProductCard
              product={product}
              selected={product.selected}
              onSelect={onSelect}
            />
          </div>
        );
      }}
    </FixedSizeGrid>
  );
}
